// frontend/src/config/config.js
// CENTRAL CONFIGURATION - Update backend URL here. API keys live in backend .env only.

const config = {
  // Backend API URL
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000',

  // Audio configuration for voice recording
  AUDIO_CONFIG: {
    sampleRate: 16000,
    channels: 1,
    bitsPerSample: 16
  },

  // App configuration
  APP_NAME: 'Voice to Text Pro',
  SESSION_EXPIRY_HOURS: 2
};

export default config;
